import styled, { css } from "styled-components";

import { Card } from "../Card";

export const StyledEntityCard = styled(Card)<{ $renderAs: string }>`
  padding: 12px;
  line-height: 1.375;

  ${(props) =>
    props.$renderAs === "list-item" &&
    css`
      display: grid;
      grid-auto-flow: column;
      align-items: center;
      min-height: 48px;
      margin-bottom: 4px;
    `}

  ${(props) =>
    props.$renderAs === "grid-item" &&
    css`
      display: flex;
      flex-direction: column;
      height: 250px;
      width: 250px;

      .card-body {
        flex-grow: 1;
      }
    `}
`;
StyledEntityCard.displayName = "StyledEntityCard";
